import type { BestReviews } from "@/lib/api/best/keywords/schema";

const countFormat = Intl.NumberFormat("en", {
  notation: "compact",
  maximumFractionDigits: 1,
});

export function formatReviewCount(reviews: BestReviews): string {
  const total = Object.values(reviews.stars).reduce((a, b) => a + b, 0);
  if (total === 0) return "0";
  return `${countFormat.format(total)}+`;
}
